import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";
import type { IConcreteEffectProps } from "../types";
import { Animatable } from "./Animatable";

export function SlideUp({
  id,
  ease,
  delay,
  active,
  duration,
  children,
  className,
  keepAlive,
}: IConcreteEffectProps) {
  return (
    <Animatable active={active} keepAlive={keepAlive}>
      <motion.div
        id={id}
        key="slideDown"
        exit={{ translateY: 20, opacity: 0 }}
        animate={{ translateY: 0, opacity: 1 }}
        initial={{ translateY: 20, opacity: 0 }}
        className={twMerge("overflow-hidden", className)}
        transition={{
          delay: delay ?? 0,
          duration: duration ?? 0.3,
          ease: ease ?? "easeOut",
        }}>
        {children}
      </motion.div>
    </Animatable>
  );
}
